"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AsyncRequest = _interopRequireDefault(require("../AsyncRequest"));

var _default = _AsyncRequest.default.createActionKeys('GET_DYNAMIC_CONFIG');

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/dynamicConfig/configActionKeys.js
// module id = 2154
// module chunks = 25